import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';

export const WORKER_ACTION_TYPES = {
	GET_WORKERS_SUCCESS: 'GET_WORKERS_SUCCESS',
    POST_WORKER_SUCCESS: 'POST_WORKER_SUCCESS',
    PUT_WORKER_SUCCESS: 'PUT_WORKER_SUCCESS',
    DELETE_WORKER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_WORKERS_PAGINATION: 'UPDATE_WORKERS_PAGINATION'
};

const WORKERS_URL = `${ENTRYPOINT}${API_ROUTES.WORKERS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getWorkers = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_WORKERS_URL = `${WORKERS_URL}${params}`;
        const response = await getData(GET_WORKERS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: WORKER_ACTION_TYPES.GET_WORKERS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: WORKER_ACTION_TYPES.UPDATE_WORKERS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getWorker = async (uuid) => {
    const GET_WORKER_URL = `${WORKERS_URL}/${uuid}`;
    return await getData(GET_WORKER_URL, getHeaders());
}

export const postWorker = (data) => (
    async (dispatch) => {
        const response = await postData(WORKERS_URL, data);
        dispatch({ type: WORKER_ACTION_TYPES.POST_WORKER_SUCCESS, payload: response });
        return response;
    }
)

export const putWorker = (uuid, data) => (
    async (dispatch) => {
        const PUT_WORKERS_URL = `${WORKERS_URL}/${uuid}`;
        const response = await putData(PUT_WORKERS_URL, data);
        dispatch({ type: WORKER_ACTION_TYPES.PUT_WORKER_SUCCESS, payload: response });
        return response;
    }
)

export const deleteWorker = (uuid) => (
    async () => {
        const DELETE_WORKER_URL = `${WORKERS_URL}/${uuid}`;
        await deleteData(DELETE_WORKER_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateWorkersPagination = ({ rowsPerPage, page = 0, filters }) =>
    (dispatch) => {
        dispatch({ type: WORKER_ACTION_TYPES.UPDATE_WORKERS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getWorkers({ page, rowsPerPage, filters }));
    }

